import api from '../api';

export const deleteRecipientsService = async (
  recipientId: string,
): Promise<void> => {
  await api.delete(`/recipients/${recipientId}`);
};
